import type { DocumentRepository } from "../repositories/document-repository"

export const makeReextractUes = (repo: DocumentRepository) =>
  (docId: string, docTypeId?: string | null) =>
    repo.reextractUes(docId, docTypeId)
